import React, { Component } from 'react'
import { compose, graphql } from 'react-apollo'
import { Route, Switch, withRouter } from 'react-router-dom'

import PropTypes from 'prop-types'

import { setAuthenticationHandler } from './../libs/authService'
import { NotificationContainer } from 'react-notifications'

import Navbar from './Navbar'
import CreateTripForm from './CreateTripForm'
import BookingSteps from './Guru/BookingSteps'
import TripGuruOrders from './Guru/Orders/TripGuruOrders'
import TravelerOrders from './Guru/Orders/TravelerOrders'
import Chat from './Chat'
import CreatePOIForm from './POIForm'
import Event from './Event'
import ActivityGuideProfile from './Guide/ActivityGuideProfile'
import CreateGuru from './Guru/CreateGuruProfile/CreateGuru'
import ActivitySteps from './ActivitySteps'
import MyTrip from './MyTrip'
import MyTripPdf from './MyTrip/MyTripPdf'
import ActivityList from './ActivityList'
import TripPlanner from './TripPlanner'
import ActivityOverview from './Activity/ActivityOverview'
import ActivityBookingSteps from './Activity/ActivityBookingSteps'
import MyTrips from './MyTrips'
import Review from './Rewiev/index'
import GuruById from './Guru/GuruById'
import ProfileSettings from './ProfileSettings'
import PrepaidTrip from './MyTrips/PrepaidTrip'
import OrderingUserDetails from './MyTrips/OrderingUserDetails'

import config from './../config'
import ReviewPOI from './Rewiev/ReviewPOI/ReviewPOI'
import ReviewTripGuru from './Rewiev/ReviewTripGuru/ReviewTripGuru'
import LocalTourReview from './Rewiev/LocalTourReview/LocalTourReview'
import ProfilePage from './ProfilePage/ProfilePage'

import CreateUser from './CreateUser'
import withLoggedInUser from './withLoggedInUser'
import { isCurrentLanguageRTL } from '../i18n'; 

import 'react-notifications/lib/notifications.css';
if (isCurrentLanguageRTL()) {
  require('../main_rtl.css')
}
else {
  require('../main_ltr.css')
}


class App extends Component {
  static propTypes = {
    data: PropTypes.object,
    history: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      chatOnTop: false,
      displayChat: false
    }
  }

  componentWillReceiveProps(nextProps) {
    /*const authRedirect = window.localStorage.getItem('authRedirect')
    if (!this.props.this.props.loggedInUser
      && !nextProps.!this.props.loggedInUserChecked
      && nextProps.this.props.loggedInUser
      && authRedirect) {
      window.localStorage.removeItem('authRedirect')
      this.props.history.push(authRedirect)
    }*/
  }

  componentDidMount() {
    setAuthenticationHandler((profile, authRedirect) => {
      this.userAuthenticated(profile, authRedirect)
    })
  }

  userAuthenticated(profile, returnTo) {
    this.props.history.push({
      pathname: '/signup',
      state: {
        email: profile.email,
        picture: profile.picture,
        returnTo: returnTo
      }
    })
  }

  redirect() {
    this.props.history.push('/')
  }

  setChatOnTop() {
    this.setState(state => ({
      chatOnTop: !state.chatOnTop,
      displayChat: !state.chatOnTop,
      menuShown: false
    }))
  }

  showChatBox = () => {
    this.setState(
      state => ({
        displayChat: !state.displayChat
      }),
      () => {
        if (!this.state.displayChat) {
          this.setState(() => ({
            chatOnTop: false
          }))
        }
      }
    )
  }

  updateAppState(data) {
    this.setState(() => data)
  }

  render() {
    const { data } = this.props
    const pathElements = this.props.location.pathname.split('/')
    return (
      <div>
        <link rel="stylesheet" type="text/css" href={this.state.stylePath} />
        <header>
          {this.props.location.pathname.indexOf('x12W') < 0 &&
          <Navbar
            clientId={config.authClientId}
            domain={config.authDomain}
            user={this.props.loggedInUser}
            loading={!this.props.loggedInUserChecked}
            setChatOnTop={() => {
              this.setChatOnTop()
            }}
            chatOnTop={this.state.chatOnTop}
            updateAppState={state => {
              this.updateAppState(state)
            }}
          />
          }
        </header>
        <main>  
          <Switch>
            <Route path="/signup" render={props => <CreateUser refreshUser={this.props.refreshUser} {...props}/>} />
            <Route path="/activity-list" component={ActivityList} />
            <Route path="/create-trip/:tripId?" render={(props)=>(<CreateTripForm user={this.props.loggedInUser} {...props}/>)}  />
            <Route path="/create-poi" render={(props)=>(<CreatePOIForm user={this.props.loggedInUser} {...props}/>)} />
            <Route path="/booking-steps/:guruId" render={(props)=>(<BookingSteps user={this.props.loggedInUser} {...props}/>)} />
            <Route path="/event" component={Event} />
            <Route path="/trip-planner/:tripId" render={props => <TripPlanner user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} {...props} />} />
            <Route path="/trip-guru-orders" render={props => <TripGuruOrders user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} {...props} />} />
            <Route
              path="/traveler-orders"
              render={props => <TravelerOrders user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              path="/profile"
              render={props => <ProfilePage refreshUser={this.props.refreshUser} user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              path="/settings"
              render={props => <ProfileSettings user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/review"
              render={props => <Review user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/review/poi/:id"
              render={props => <ReviewPOI user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/review/trip-guru/:id"
              render={props => <ReviewTripGuru user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/review/activity-guide/:id"
              render={props => <ReviewTripGuru user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/review/localtour/:id"
              render={props => <LocalTourReview user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              path="/activity-guide-profile"
              render={props => 
                <ActivityGuideProfile 
                  user={this.props.loggedInUser} 
                  loading={!this.props.loggedInUserChecked} 
                  redirect={() => this.redirect()} 
                  {...props} 
                />}
            />
            <Route
              path="/create-guru-profile"
              render={props => (
                <CreateGuru
                  user={this.props.loggedInUser}
                  loading={!this.props.loggedInUserChecked}
                  showChatBox={this.showChatBox}
                  redirect={() => this.redirect()}
                  {...props}
                />
              )}
            />
            <Route
              exact
              path="/activity-steps"
              render={props => <ActivitySteps user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/activity-steps/:id/:step?"
              render={props => <ActivitySteps user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              path="/activity/:id"
              render={props => (
                <ActivityOverview
                  user={this.props.loggedInUser}
                  updateState={state => {
                    this.updateAppState(state)
                  }}
                  loading={!this.props.loggedInUserChecked}
                  redirect={() => this.redirect()}
                  {...props}
                />
              )}
            />
            <Route
              path="/activity-booking-steps/:id?"
              render={props => (
                <ActivityBookingSteps
                  user={this.props.loggedInUser}
                  chosenDate={this.state.chosenDate}
                  loading={!this.props.loggedInUserChecked}
                  redirect={() => this.redirect()}
                  {...props}
                />
              )}
            />
            <Route
              exact
              path="/my-plans"
              render={props => <MyTrips user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/my-trips"
              render={props => <MyTrips user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} showTrips={true} redirect={() => this.redirect()} {...props} />}
            />
            <Route exact path="/my-trips/:id" render={props => <MyTrip user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} {...props} />} />
            <Route exact path="/my-trips/x12W/:id" render={props => <MyTrip user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} expandAll={true} {...props} />} />
            <Route exact path="/gurus/guru-profile/:id" render={props => <GuruById showChatBox={this.showChatBox} {...props} />} />
            <Route
              exact
              path="/prepaid-trip"
              render={props => <PrepaidTrip user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
            <Route
              exact
              path="/edit-order-user-details/:id"
              render={props => <OrderingUserDetails user={this.props.loggedInUser} loading={!this.props.loggedInUserChecked} redirect={() => this.redirect()} {...props} />}
            />
</Switch>
          {this.props.loggedInUser && pathElements.indexOf('activity-steps') === -1 ? (
            <Chat
              user={this.props.loggedInUser}
              setOnTop={this.state.chatOnTop}
              setChatOnTop={() => this.setChatOnTop()}
              chatOnTop={this.state.chatOnTop}
              showChatBox={this.showChatBox}
              displayChat={this.state.displayChat}
              notificationInNavbar={this.state.menuShown}
            />
          ) : (
            ''
          )}
        </main>
        <NotificationContainer/>
      </div>
    )
  }
}

export default compose(
  withLoggedInUser,
  withRouter
)(App)



// WEBPACK FOOTER //
// src/components/App.jsx